import './independentrestaurantconcepts/style';
import FormStructure from './independentrestaurantconcepts/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/includes.js